import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";
// Connects to data-controller="shipping-fields-toggle"
export default class extends Controller {
  static values = {
    url: String,
  };

  async toggle(e) {
    const shippingFields = document.getElementById("shipping-info");

    if (shippingFields) {
      if (e.currentTarget.value === "shipping") {
        shippingFields.removeAttribute("hidden");
        if (this.hasUrlValue) {
          shippingFields.querySelectorAll("input, select, textarea").forEach((field) => {
            field.required = true;
          });
        }
      } else {
        shippingFields.setAttribute("hidden", true);
        shippingFields.querySelectorAll("input, select, textarea").forEach((field) => {
          field.required = false;
        });
      }
    }

    if (this.hasUrlValue) {
      await post(this.urlValue, {
        body: JSON.stringify({
          fulfillment_option: e.currentTarget.value,
        }),
      });
    }
  }
}
